module.exports = __webpack_public_path__ + "static/img/e2.e1762dc1.png";